var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2010_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.99 21.98H10.02C9.66002 21.98 9.33001 21.79 9.15001 21.48C8.97001 21.17 8.97001 20.79 9.15001 20.48L15.14 10.11C15.5 9.48999 16.52 9.48999 16.87 10.11L22.86 20.48C23.04 20.79 23.04 21.17 22.86 21.48C22.68 21.79 22.35 21.98 21.99 21.98ZM11.75 19.98H20.26L16.01 12.61L11.76 19.98H11.75Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.49C15.59 17.49 15.25 17.15 15.25 16.74V15.61C15.25 15.2 15.59 14.86 16 14.86C16.41 14.86 16.75 15.2 16.75 15.61V16.74C16.75 17.15 16.41 17.49 16 17.49Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.46C16.4197 19.46 16.76 19.1197 16.76 18.7C16.76 18.2803 16.4197 17.94 16 17.94C15.5803 17.94 15.24 18.2803 15.24 18.7C15.24 19.1197 15.5803 19.46 16 19.46Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2010_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAlert);
export default __webpack_public_path__ + "static/media/HomeAlert.915fc161019b054731f9790856111857.svg";
export { ForwardRef as ReactComponent };